import { faCircleXmark, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';

const Slideout = ({ open, setOpen, title, children, width = "sm", subSlideoutContent = null, subSlideoutTitle = "Additional Information", subSlideoutWidth = "sm" }) => {
  const [subSlideoutOpen, setSubSlideoutOpen] = useState(false);

  const widthClasses = {
    sm: 'max-w-xl',
    md: 'max-w-3xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
  };

  const subSlideoutWidthClasses = {
    sm: 'w-80',
    md: 'w-96',
    lg: 'w-[28rem]',
    xl: 'w-[32rem]',
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[101]" onClose={() => setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              {subSlideoutContent && (
                <Transition
                  show={subSlideoutOpen}
                  as={Fragment}
                  enter="transform transition ease-in-out duration-300"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-300"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <div className={`pointer-events-auto ${subSlideoutWidthClasses[subSlideoutWidth]} bg-white shadow-xl border-l`}>
                    <div className="flex h-full flex-col overflow-y-auto">
                      <div className="bg-gray-100 px-4 py-6 border-b">
                        <div className="flex items-center justify-between">
                          <h3 className="text-lg font-semibold leading-6 text-gray-900">
                            {subSlideoutTitle}
                          </h3>
                          <button
                            type="button"
                            className="rounded-md bg-gray-100 text-gray-600 hover:text-gray-800 focus:outline-none"
                            onClick={() => setSubSlideoutOpen(false)}
                          >
                            <span className="sr-only">Close sub panel</span>
                            <FontAwesomeIcon icon={faChevronRight} />
                          </button>
                        </div>
                      </div>
                      <div className="relative flex-1 p-4">
                        {subSlideoutContent}
                      </div>
                    </div>
                  </div>
                </Transition>
              )}

              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300 sm:duration-500"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300 sm:duration-500"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className={`pointer-events-auto w-screen ${widthClasses[width]} bg-white shadow-xl relative`}>
                  {subSlideoutContent && (
                    <button
                      onClick={() => setSubSlideoutOpen(!subSlideoutOpen)}
                      className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-full bg-white border border-r-0 rounded-l-md px-2 py-3 shadow-lg hover:bg-gray-50 focus:outline-none z-10"
                      title={subSlideoutTitle}
                    >
                      <FontAwesomeIcon
                        icon={subSlideoutOpen ? faChevronRight : faChevronLeft}
                        className="text-gray-600"
                      />
                    </button>
                  )}

                  <div className="flex h-full flex-col overflow-y-auto">
                    <div className="bg-sas px-4 py-6">
                      <div className="flex items-center justify-between">
                        <Dialog.Title className="text-lg font-semibold leading-6 text-white">
                          {title}
                        </Dialog.Title>
                        <button
                          type="button"
                          className="rounded-md bg-sas text-white hover:text-sas-dark focus:outline-none"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>
                          <FontAwesomeIcon icon={faCircleXmark} />
                        </button>
                      </div>
                    </div>
                    <div className="relative flex-1 p-4">
                      {children}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Slideout;